import { useHistory } from "react-router-dom";

import { WebSocketComponent, clearAllItemsPersisted } from "components";
import { typedQueryClient } from "hooks";
import { logoutZohoDeskASAP } from "plugins/ZohoDeskASAP";
import { sessionBroadcastChannel } from "router/components";
import { PATHS } from "router/paths";
import { clearLocalStorageValues } from "utils/storageUtil";

export const useLogout = (broadcastLogoutMessage: boolean = true) => {
  const history = useHistory();

  return () => {
    if (history.location.pathname === PATHS.LOGIN) return;

    history.replace(PATHS.LOGIN);
    WebSocketComponent.disconnect();
    clearAllItemsPersisted();
    clearLocalStorageValues();
    logoutZohoDeskASAP();
    typedQueryClient.clear();
    if (broadcastLogoutMessage) sessionBroadcastChannel.postMessage({ type: "LOGOUT" });
  };
};
